import { FONTS } from "../FdDesignSetting/premiumDesign";

// 글 텍스트 모듈: 편집기(Tiptap) 문서 JSON ↔ 서버 블록 [{ type: PARAGRAPH|HEADING, align?, spans: [{ text, bold?, size?, color?, font? }] }]
// 편집기 스키마가 문단·제목(h2)·굵게·글자 꾸미기(textStyle)·정렬·줄바꿈만 가지므로 그 밖의 노드는 오지 않는다. 사진은 이미지 모듈.

// 글자 꾸미기 값. 서버 PostsUseCase(TEXT_*) · 공개 페이지 PostBody.jsx 와 같아야 한다. 크기는 문단 글자 대비 배율
export const TEXT_SIZES = [
    { value: 'SMALL', label: '작게', em: 0.875 },
    { value: null, label: '보통' },
    { value: 'LARGE', label: '크게', em: 1.25 },
    { value: 'XLARGE', label: '아주 크게', em: 1.5 },
];
export const TEXT_COLORS = ['#111111', '#6B7280', '#EF4444', '#F59E0B', '#10B981', '#3B82F6', '#8B5CF6', '#EE9CA7'];
export const TEXT_ALIGNS = ['LEFT', 'CENTER', 'RIGHT'];

/** 글자 조각 꾸미기 → style (편집기·미리보기 공용) */
export function spanStyle({ size, color, font }) {
    return {
        ...(size ? { fontSize: `${TEXT_SIZES.find(s => s.value === size)?.em}em` } : {}),
        ...(color ? { color } : {}),
        ...(font ? { fontFamily: FONTS.find(f => f.value === font)?.family } : {}),
    };
}

export const alignClass = (align) => (align === 'CENTER' ? 'text-center' : align === 'RIGHT' ? 'text-right' : '');

const STYLE_KEYS = ['size', 'color', 'font'];

/** 블록 → 편집기 문서 */
export function blocksToDoc(blocks = []) {
    const content = blocks.map(b => {
        // 글자 안 \n 은 줄바꿈(hardBreak)
        const nodes = b.spans.flatMap(s => {
            const style = Object.fromEntries(STYLE_KEYS.filter(k => s[k]).map(k => [k, s[k]]));
            const marks = [
                ...(s.bold ? [{ type: 'bold' }] : []),
                ...(Object.keys(style).length ? [{ type: 'textStyle', attrs: style }] : []),
            ];
            return s.text.split('\n').flatMap((part, i) => [
                ...(i ? [{ type: 'hardBreak' }] : []),
                ...(part ? [{ type: 'text', text: part, ...(marks.length ? { marks } : {}) }] : []),
            ]);
        });
        const textAlign = b.align ? b.align.toLowerCase() : null;
        return {
            ...(b.type === 'HEADING' ? { type: 'heading', attrs: { level: 2, textAlign } } : { type: 'paragraph', attrs: { textAlign } }),
            ...(nodes.length ? { content: nodes } : {}),
        };
    });
    return { type: 'doc', content: content.length ? content : [{ type: 'paragraph' }] };
}

/** 편집기 문서 → 블록 */
export function docToBlocks(doc) {
    const blocks = (doc?.content || []).map(node => {
        const spans = [];
        (node.content || []).forEach(child => {
            const isBreak = child.type === 'hardBreak';
            const text = isBreak ? '\n' : (child.text || '');
            const attrs = child.marks?.find(m => m.type === 'textStyle')?.attrs || {};
            const style = {
                ...(child.marks?.some(m => m.type === 'bold') ? { bold: true } : {}),
                ...Object.fromEntries(STYLE_KEYS.filter(k => attrs[k]).map(k => [k, attrs[k]])),
            };
            const last = spans[spans.length - 1];
            // 줄바꿈은 꾸미기가 없으니 앞 조각에 붙인다 (꾸민 글 사이 줄바꿈이 조각을 쪼개지 않게)
            if (last && (isBreak || ['bold', ...STYLE_KEYS].every(k => last[k] === style[k]))) {
                last.text += text;
            } else if (text) {
                spans.push({ text, ...style });
            }
        });
        const align = node.attrs?.textAlign?.toUpperCase();
        return { type: node.type === 'heading' ? 'HEADING' : 'PARAGRAPH', spans, ...(align === 'CENTER' || align === 'RIGHT' ? { align } : {}) };
    });

    // 끝의 빈 줄은 버린다
    while (blocks.length && !blocks[blocks.length - 1].spans.length) {
        blocks.pop();
    }
    return blocks;
}

/** 텍스트 블록에 글자가 있는지 */
export function hasText(blocks) {
    return blocks.some(b => b.spans.some(s => s.text.trim()));
}
